import BoxBody from 'components/BoxBody.jsx';
import Dialog from 'components/Dialog.jsx';
import MessageActions from 'groups/actions/MessageActions';
import MessageStore from 'groups/stores/MessageStore';
import GroupMessageList from 'groups/components/GroupMessageList.jsx';
import GroupStore from 'groups/stores/GroupStore';
import PropTypes from 'prop-types';
import React from 'react';
import ToastActions from 'actions/ToastActions';

export default class GroupMessageListModal extends React.Component {
  static propTypes = {
    groupCode: PropTypes.string.isRequired,
  };

  componentWillMount() {
    this.group = GroupStore.getGroupForCode(this.props.groupCode);

    if (!this.group) {
      ToastActions.showErrorToast('You are no longer in this group.');
      return;
    }

    const groupId = this.group.id;
    if (!MessageStore.isDoneLoadingForGroup(groupId)) {
      MessageActions.loadMessages(groupId);
    }
  }

  render() {
    if (!this.group) {
      return null;
    }

    return (
      <Dialog
        {...this.props}
        textAlign="left"
        className="GroupMessageListModal"
        eventScreenName="GroupMessageListModal">
        <BoxBody>
          <GroupMessageList group={this.group} />
        </BoxBody>
      </Dialog>
    );
  }
}
